import { TranslationLanguage } from '@gitbook/api-client';
import { arrayOfAll } from '@gitbook/util-ts';

export const allTranslationLanguages = arrayOfAll<TranslationLanguage>()([
    TranslationLanguage.En, // English
    TranslationLanguage.Fr, // French
    TranslationLanguage.De, // German
    TranslationLanguage.Es, // Spanish
    TranslationLanguage.It, // Italian
    TranslationLanguage.Pt, // Portuguese
    TranslationLanguage.PtBr, // Brazilian Portuguese
    TranslationLanguage.Ru, // Russian
    TranslationLanguage.Ja, // Japanese
    TranslationLanguage.Zh, // Chinese
    TranslationLanguage.Yue, // Cantonese
    TranslationLanguage.Ko, // Korean
    TranslationLanguage.Ar, // Arabic
    TranslationLanguage.Hi, // Hindi
    TranslationLanguage.Nl, // Dutch
    TranslationLanguage.Pl, // Polish
    TranslationLanguage.Tr, // Turkish
    TranslationLanguage.Sv, // Swedish
    TranslationLanguage.No, // Norwegian
    TranslationLanguage.Da, // Danish
    TranslationLanguage.Fi, // Finnish
    TranslationLanguage.El, // Greek
    TranslationLanguage.Cs, // Czech
    TranslationLanguage.Hu, // Hungarian
    TranslationLanguage.Ro, // Romanian
    TranslationLanguage.Th, // Thai
    TranslationLanguage.Vi, // Vietnamese
    TranslationLanguage.Id, // Indonesian
    TranslationLanguage.Ms, // Malay
    TranslationLanguage.He, // Hebrew
    TranslationLanguage.Uk, // Ukrainian
    TranslationLanguage.Sk, // Slovak
    TranslationLanguage.Bg, // Bulgarian
    TranslationLanguage.Hr, // Croatian
    TranslationLanguage.Lt, // Lithuanian
    TranslationLanguage.Lv, // Latvian
    TranslationLanguage.Et, // Estonian
    TranslationLanguage.Sl, // Slovenian
]);

export const translationLanguageDescriptors: Record<
    TranslationLanguage,
    {
        label: string;
        /** UTF-8 HEX code point of the flag emoji */
        emoji: string;
    }
> = {
    [TranslationLanguage.En]: { label: 'English', emoji: '1f1fa-1f1f8' }, // 🇺🇸
    [TranslationLanguage.Fr]: { label: 'French', emoji: '1f1eb-1f1f7' }, // 🇫🇷
    [TranslationLanguage.De]: { label: 'German', emoji: '1f1e9-1f1ea' }, // 🇩🇪
    [TranslationLanguage.Es]: { label: 'Spanish', emoji: '1f1ea-1f1f8' }, // 🇪🇸
    [TranslationLanguage.It]: { label: 'Italian', emoji: '1f1ee-1f1f9' }, // 🇮🇹
    [TranslationLanguage.Pt]: { label: 'Portuguese', emoji: '1f1f5-1f1f9' }, // 🇵🇹
    [TranslationLanguage.PtBr]: { label: 'Brazilian Portuguese', emoji: '1f1e7-1f1f7' }, // 🇧🇷
    [TranslationLanguage.Ru]: { label: 'Russian', emoji: '1f1f7-1f1fa' }, // 🇷🇺
    [TranslationLanguage.Ja]: { label: 'Japanese', emoji: '1f1ef-1f1f5' }, // 🇯🇵
    [TranslationLanguage.Zh]: { label: 'Chinese', emoji: '1f1e8-1f1f3' }, // 🇨🇳
    [TranslationLanguage.Yue]: { label: 'Cantonese', emoji: '1f1ed-1f1f0' }, // 🇭🇰
    [TranslationLanguage.Ko]: { label: 'Korean', emoji: '1f1f0-1f1f7' }, // 🇰🇷
    [TranslationLanguage.Ar]: { label: 'Arabic', emoji: '1f1f8-1f1e6' }, // 🇸🇦
    [TranslationLanguage.Hi]: { label: 'Hindi', emoji: '1f1ee-1f1f3' }, // 🇮🇳
    [TranslationLanguage.Nl]: { label: 'Dutch', emoji: '1f1f3-1f1f1' }, // 🇳🇱
    [TranslationLanguage.Pl]: { label: 'Polish', emoji: '1f1f5-1f1f1' }, // 🇵🇱
    [TranslationLanguage.Tr]: { label: 'Turkish', emoji: '1f1f9-1f1f7' }, // 🇹🇷
    [TranslationLanguage.Sv]: { label: 'Swedish', emoji: '1f1f8-1f1ea' }, // 🇸🇪
    [TranslationLanguage.No]: { label: 'Norwegian', emoji: '1f1f3-1f1f4' }, // 🇳🇴
    [TranslationLanguage.Da]: { label: 'Danish', emoji: '1f1e9-1f1f0' }, // 🇩🇰
    [TranslationLanguage.Fi]: { label: 'Finnish', emoji: '1f1eb-1f1ee' }, // 🇫🇮
    [TranslationLanguage.El]: { label: 'Greek', emoji: '1f1ec-1f1f7' }, // 🇬🇷
    [TranslationLanguage.Cs]: { label: 'Czech', emoji: '1f1e8-1f1ff' }, // 🇨🇿
    [TranslationLanguage.Hu]: { label: 'Hungarian', emoji: '1f1ed-1f1fa' }, // 🇭🇺
    [TranslationLanguage.Ro]: { label: 'Romanian', emoji: '1f1f7-1f1f4' }, // 🇷🇴
    [TranslationLanguage.Th]: { label: 'Thai', emoji: '1f1f9-1f1ed' }, // 🇹🇭
    [TranslationLanguage.Vi]: { label: 'Vietnamese', emoji: '1f1fb-1f1f3' }, // 🇻🇳
    [TranslationLanguage.Id]: { label: 'Indonesian', emoji: '1f1ee-1f1e9' }, // 🇮🇩
    [TranslationLanguage.Ms]: { label: 'Malay', emoji: '1f1f2-1f1fe' }, // 🇲🇾
    [TranslationLanguage.He]: { label: 'Hebrew', emoji: '1f1ee-1f1f1' }, // 🇮🇱
    [TranslationLanguage.Uk]: { label: 'Ukrainian', emoji: '1f1fa-1f1e6' }, // 🇺🇦
    [TranslationLanguage.Sk]: { label: 'Slovak', emoji: '1f1f8-1f1f0' }, // 🇸🇰
    [TranslationLanguage.Bg]: { label: 'Bulgarian', emoji: '1f1e7-1f1ec' }, // 🇧🇬
    [TranslationLanguage.Hr]: { label: 'Croatian', emoji: '1f1ed-1f1f7' }, // 🇭🇷
    [TranslationLanguage.Lt]: { label: 'Lithuanian', emoji: '1f1f1-1f1f9' }, // 🇱🇹
    [TranslationLanguage.Lv]: { label: 'Latvian', emoji: '1f1f1-1f1fb' }, // 🇱🇻
    [TranslationLanguage.Et]: { label: 'Estonian', emoji: '1f1ea-1f1ea' }, // 🇪🇪
    [TranslationLanguage.Sl]: { label: 'Slovenian', emoji: '1f1f8-1f1ee' }, // 🇸🇮
};
